var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Fellow",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#6E4FF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2 6.5h4.1c2.2 0 3.6 1.2 3.6 3.1 0 1.3-.7 2.2-1.8 2.7 1.4.4 2.3 1.5 2.3 3.1 0 2.1-1.6 3.4-4.2 3.4H8.2V6.5zm2 4.8h1.9c1 0 1.6-.5 1.6-1.3 0-.8-.6-1.3-1.6-1.3h-1.9v2.6zm0 5.2h2.2c1.1 0 1.8-.6 1.8-1.5 0-.9-.7-1.5-1.8-1.5h-2.2v3z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFellow);
export default __webpack_public_path__ + "static/media/fellow.3369cbea12c46b065459a657b674f2c1.svg";
export { ForwardRef as ReactComponent };